import React, { useState } from "react";
import { BsFillStarFill } from "react-icons/bs";
import { GoArrowUpRight } from "react-icons/go";

const DoctorCard = ({ doctor, onBook }) => {
  const [hovered, setHovered] = useState(false);

  const defaultUrl =
    "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png";

  const specialities = doctor?.specialities
    ?.map((i) => i.specialityName)
    .join(", ");

  const getDoctorName = () => {
    const first = doctor?.firstName || "";
    const last = doctor?.lastName || "";

    const fullName = `${first} ${last}`.trim();
    const cleanedName = fullName.replace(/^dr\.?\s*/i, "");

    return `Dr. ${cleanedName}`;
  };

  return (
    <div
      onClick={() => onBook(doctor._id, doctor)}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      className="relative cursor-pointer rounded-3xl shadow-md p-3 overflow-hidden 
transition-all duration-300 hover:scale-105 hover:shadow-lg h-full flex flex-col"
      style={{
        background: hovered
          ? "linear-gradient(to bottom, #8F6BCB 0%, #E6A9CF 100%)"
          : "#ffffff",
        border: hovered ? "2px solid #9A72C9" : "transparent",
        transition: "all 0.35s ease",
      }}
    >
      {/* Arrow */}
      <div
        className="absolute right-4 top-4 flex items-center justify-center rounded-full w-12 h-12 bg-white "
        style={{ opacity: hovered ? 1 : 0, transition: "0.3s" }}
      >
        <GoArrowUpRight className="w-6 h-6 text-primary" />
      </div>

      {/* Image */}
      <div className="w-full h-72 overflow-hidden rounded-3xl">
        <img
          src={doctor?.profilePic?.original || doctor?.profilePic?.thumbnail || defaultUrl}
          alt="doctor"
          // className="w-full h-full object-contain"
          className="w-full h-full object-conatin shrink-0"
        />
      </div>

      {/* Default Info */}
      <div
        className="p-4"
        style={{
          opacity: hovered ? 0 : 1,
          transition: "opacity 0.2s",
        }}
      >
        <div className="flex items-center space-x-6">
          <h3 className="font-semibold text-lg line-clamp-1">
            {getDoctorName()}
          </h3>

          <div className="flex items-center text-base">
            <BsFillStarFill className="text-primary mr-1 " />
            <span>{doctor?.avgRatings || "5.0"}</span>
          </div>
        </div>

        <p className="text-dark text-base mt-1 line-clamp-2">{specialities}</p>
      </div>

      {/* Hover Info Panel */}
      <div
        className="absolute left-3 right-3 bottom-3 p-5 border-2 border-primary rounded-2xl shadow-xl z-20"
        style={{
          background: "#ffffff",
          transform: hovered ? "translateY(0)" : "translateY(110%)",
          transition: "transform 0.35s ease",
        }}
      >
        <div className="flex items-center space-x-6">
          <h3 className="font-semibold text-lg  line-clamp-1">
            {getDoctorName()}
          </h3>

          <div className="flex items-center text-base">
            <BsFillStarFill className="text-primary mr-1 " />
            <span>{doctor?.avgRatings || "5.0"}</span>
          </div>
        </div>

        <p className="text-Textgray text-base mt-1 line-clamp-2">
          {specialities}
        </p>

        <p className=" text-xs mt-2 line-clamp-3">
          {doctor?.bio ||
            "My focus has always been on providing patient-centered and personalized care to everyone I serve."}
        </p>

        <div className="mt-3 font-bold text-primary text-lg">
          {/* Rs. {doctor?.consultationFeeAudioVideo} */}
          $ {doctor?.consultationFeeAudioVideo}
        </div>
      </div>
    </div>
  );
};

export default DoctorCard;
